module.exports = __webpack_public_path__ + "static/workfront-dc648b4d93999848b74483f407da9af2.png";